<div class="add-vehicle container-fluid">
  <div class="row ">
    <div class="col-md-8 vehicle-title">
      <label>{{pageTitle}}</label>
    </div>
    <div class="col-md-4" style="text-align:right">
      <button type="button" class="btn btn-default" routerLink="/admin/vehicle">{{"Button.view_vehicle_models_list" | translate}}</button>
    </div>
  </div>

  <span class="card" [ngStyle]="{'opacity': isViewMode ? '0.7':'1'}">
    <div class="card-block">
      <div class="card-body">

        <div class="row">
          <div class="col-md-12 mt-2">
            <div class="row" *ngFor="let alert of alerts" class="padding-b-15">
              <div class="alert alert-dismissible" [ngClass]="{'alert-danger': alert.type === 'error','alert-success': alert.type === 'success'}">
                <button type="button" class="close" data-dismiss="alert" (click)="closeAlerts()">×</button>
                {{ alert.msg }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <mat-form-field class="col-md-5">
            <input [disabled]="isViewMode" matInput placeholder="Vehicle Model" [matAutocomplete]="auto" required name="vehiclemodel"
              #vehiclemodel="ngModel" [(ngModel)]="vehicle.model">
            <mat-autocomplete #auto="matAutocomplete">
              <mat-option *ngFor="let model of models" [value]="model.model">
                {{model.model}}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
          <div class="col-md-1"></div>
          <mat-form-field class="col-md-5">
            <input [disabled]="isViewMode" maxlength="4" matInput placeholder="Vehicle Year" type="number" pattern="^\d{4}$"
              required name="vehicleYear" #vehicleYear="ngModel" [(ngModel)]="year.year">
          </mat-form-field>
          <div class="col-md-1" style="float:right">
            <span class="action-controls" [ngStyle]="{'visibility': isViewMode ? 'visible' : 'hidden'}">
              <button id="edit-view" class="action-btn" type="button" (click)="editView()">
                <img alt="Edit" class="action-icon" [src]="commonService.commonFiles['edit']" alt="Edit">
              </button>
            </span>
          </div>
          <div class="col-md-5">
            <mat-error *ngIf="showError && vehiclemodel.invalid">
              <div *ngIf="vehiclemodel.errors.required">Vehicle Model is required</div>
            </mat-error>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-4">
            <mat-error *ngIf="showError && vehicleYear.invalid">
              <div *ngIf="vehicleYear.errors.required">Vehicle Year is required</div>
            </mat-error>
            <mat-error *ngIf="showError && vehicleYear.invalid">
              <div *ngIf="!vehicleYear.errors.required">Enter valid vehicle year.</div>
            </mat-error>
          </div>
          <mat-form-field class="col-md-5">
            <input maxlength="25" matInput placeholder="Vehicle Generation" required name="vehicleGeneration" #vehicleGeneration="ngModel"
              [(ngModel)]="year.generation">
          </mat-form-field>
          <div class="col-md-1"></div>
          <mat-form-field class="col-md-5">
            <mat-label>Vehicle Classification</mat-label>
            <mat-select [disabled]="isViewMode" [(ngModel)]="vehicle.classification" required name="classification" #classification="ngModel">
              <mat-option *ngFor="let classification of classifications " [value]="classification">
                {{classification}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class=" col-md-5" style="float: left;">
            <mat-error *ngIf="showError && vehicleGeneration.invalid">
              <div *ngIf="vehicleGeneration.errors.required" style="float: left;">Vehicle Generation is required</div>
            </mat-error>
          </div>
          <div class="col-md-1"></div>
          <div class=" col-md-5" style="float: left;">
            <mat-error *ngIf="showError && classification.invalid">
              <div *ngIf="classification.errors.required" style="float: left;"> Vehicle Classification is required</div>
            </mat-error>
          </div>
          <mat-form-field class="col-md-5">
            <textarea [disabled]="isViewMode" matInput placeholder="Vehicle Model Codes" required name="modelCodes" #modelCodes="ngModel"
              pattern="^[0-9\n,.-]*$" rows="3" [(ngModel)]="vehicle.modelCodes">
           </textarea>
          </mat-form-field>
          <div class="col-md-1"></div>
          <div class=" col-md-6"></div>
          <div class=" col-md-6">
            <mat-error *ngIf="showError && modelCodes.invalid">
              <div *ngIf="modelCodes.errors.required">Vehicle ModelCodes is required</div>
            </mat-error>
            <mat-error *ngIf="showError && modelCodes.invalid">
              <div *ngIf="modelCodes.errors?.pattern">Vehicle ModelCodes not Valid</div>
            </mat-error>
          </div>
        </div>
        <div class="row">
          <mat-checkbox class="col-md-5" [hidden]="isViewMode" [checked]="showExisting" (change)="showExistingChange()" name="notes"
            [(ngModel)]="showExisting" labelPosition="before">{{ "Label.copy_existing" | translate}}
          </mat-checkbox>
          <div class="col-md-1"></div>
        </div>

        <div *ngIf="showExisting">
          <div class="row">
            <mat-form-field class="col-md-5 example-full-width">
              <mat-label>Existing Vehicle Model</mat-label>
              <mat-select [disabled]="isViewMode || vehicle.model == null || year.year == null" (selectionChange)="onModelChange($event)"
                [(ngModel)]="existingModel" name="existingmodel" #existingmodel="ngModel">
                <mat-option *ngFor="let model of existingModels " [value]="model.model ">
                  {{model.model}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <div class="col-md-1"></div>
            <mat-form-field class="col-md-5 example-full-width">
              <mat-label>Year</mat-label>
              <mat-select [disabled]="isViewMode || !existingModel" [(ngModel)]="existingYear" name="existingyear" #existingyear="ngModel">
                <mat-option *ngFor="let year of existingYears " [value]="year">
                  {{year}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <span class="col-md-3">
              <button [disabled]="isViewMode" [hidden]="!(existingModel != null && existingYear != null)" type="button" class="btn btn-default"
                (click)="onFeatureCopy();">
                {{ "Button.copy" | translate}}</button>
            </span>
          </div>
        </div>

        <div class="row">
          <mat-form-field class="col-md-5 example-full-width">
            <mat-select [disabled]="vehicle.model == null || year.year == null || isViewMode" placeholder="Support Topics" (selectionChange)="supportTopicChange($event.value)"
              [(ngModel)]="year.features" multiple>
              <mat-option *ngFor="let feature of dropdownList" [value]="feature.issueId">{{feature.featureName}}
              </mat-option>
            </mat-select>
          </mat-form-field>

        </div>

        <div class="row" *ngIf="year.features && year.features.length > 0">
          <div class="col-md-5">
            <mat-card>
              <mat-card-header>
                <mat-card-title>External</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div *ngFor="let feature of year.features">
                  <div *ngFor="let item of externalFeatureList;let itemIndex=index;">
                    <div *ngIf="item.issueId==feature && item.featureType == 'external'" class="control-list">
                      <span class="ellipsis" [matTooltip]="item.featureName" matTooltipPosition="below" matTooltipClass="tooltip-class">{{item.featureName}}-{{item.featureType}}</span>

                      <span class="action-controls">
                        <button [disabled]="isViewMode" type="button" class="ml-2 action-btn" type="button" (click)="openConfirmDialog(item)">
                          <img alt="Delete" class="action-icon" [src]="commonService.commonFiles['delete']" alt="Delete">
                        </button>
                        <span *ngIf="year.features.length > 1" class="ml-2">
                          <button type="button" [disabled]="isViewMode" (click)="changeOrder(item,'up',itemIndex,'external');" class="up-arrow fa fa-caret-up"></button>
                          <button type="button" [disabled]="isViewMode" (click)="changeOrder(item,'down',itemIndex,'external');" class="down-arrow fa fa-caret-down"></button>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="col-md-1"></div>
          <div class="col-md-5">
            <mat-card>
              <mat-card-header>
                <mat-card-title>Internal</mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <div *ngFor="let feature of year.features">
                  <div *ngFor="let item of internalFeatureList;let itemIndex=index;">
                    <div *ngIf="item.issueId==feature && item.featureType == 'internal'" class="control-list">
                      <span class="ellipsis" [matTooltip]="item.featureName" matTooltipPosition="below" matTooltipClass="tooltip-class">{{item.featureName}}-{{item.featureType}}</span>
                      <span class="action-controls">
                        <button [disabled]="isViewMode" type="button" class="ml-2 action-btn" type="button" (click)="openConfirmDialog(item)">
                          <img alt="Delete" class="action-icon" [src]="commonService.commonFiles['delete']" alt="Delete">
                        </button>
                        <span *ngIf="year.features.length > 1" class="ml-2">
                          <button type="button" [disabled]="isViewMode" (click)="changeOrder(item,'up',itemIndex,'internal');" class="up-arrow fa fa-caret-up"></button>
                          <button type="button" [disabled]="isViewMode" (click)="changeOrder(item,'down',itemIndex,'internal');" class="down-arrow fa fa-caret-down"></button>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-md-12 col-lg-12 d-flex">
            <span class="float-right ml-auto controls-right">
              <span class="save-btn">
                <button [disabled]="isViewMode" type="button" class="btn btn-default btn-save" (click)="onSave();">
                  {{ "Button.save" | translate}}</button>
              </span>
              <span class="ml-2">
                <button [disabled]="isViewMode" type="button" class="btn btn-secondary" (click)="onCancel();">
                  {{ "Button.cancel" | translate}}</button>
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </span>
</div>